import React, { ComponentProps, useMemo, useState } from 'react'

import styled from '@emotion/styled'

import { Minus, Plus } from '@surglogs-app/icons'

import { Box } from './Box'
import { Divider } from './Divider'
import { FlexBox } from './FlexBox'
import { Icon } from './Icon'
import { TextButton } from './TextButton'

export const ExpandableBoxButton = styled(TextButton)`
  display: flex;
  align-items: center;
  white-space: nowrap;
  gap: ${({ theme }) => theme.ui.spacings.xs};
  margin-right: ${({ theme }) => theme.ui.spacings.md};
`

interface ExpandableBoxProps extends ComponentProps<typeof Box> {
  defaultOpen?: boolean
  expandLabel: string
  hideLabel: string
}

export const ExpandableBox = ({
  children,
  defaultOpen = false,
  expandLabel,
  hideLabel,
  ...rest
}: ExpandableBoxProps) => {
  const [isExpanded, setIsExpanded] = useState(defaultOpen)

  const label = useMemo(() => {
    if (!hideLabel || !expandLabel) {
      return null
    }

    return isExpanded ? hideLabel : expandLabel
  }, [expandLabel, hideLabel, isExpanded])

  return (
    <Box {...rest}>
      {isExpanded ? <Box>{children}</Box> : null}

      <FlexBox {...{ flex: '1', ai: 'center' }}>
        <ExpandableBoxButton
          {...{
            variant: 'default',
            onClick: () => setIsExpanded((prev) => !prev),
          }}>
          <Icon {...{ icon: isExpanded ? Minus : Plus, color: 'inherit' }} />
          {label}
        </ExpandableBoxButton>
        <Divider />
      </FlexBox>
    </Box>
  )
}
